(function () {
  'use strict';

  function initFa(section) {
    var slides = section.querySelectorAll('.ost-fa__slide');
    var dots   = section.querySelectorAll('.ost-fa__dot');
    var count  = slides.length;
    if (!count) return;

    var rafId = null;

    function update() {
      if (window.innerWidth <= 989) return;
      var rect = section.getBoundingClientRect();
      var scrollable = rect.height - window.innerHeight;
      if (scrollable <= 0) return;

      var progress = Math.max(0, Math.min(1, -rect.top / scrollable));
      var offset   = progress * (count - 1);

      slides.forEach(function (slide, i) {
        slide.style.transform = 'translateY(' + ((i - offset) * 100).toFixed(3) + '%)';
      });

      var active = Math.min(count - 1, Math.round(offset));
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === active); });
    }

    function onScroll() {
      cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(update);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    update();
  }

  function fixVideos(root) {
    (root || document).querySelectorAll('.ost-fa__slide video').forEach(function (v) {
      v.setAttribute('playsinline', '');
    });
  }

  fixVideos();
  document.querySelectorAll('.ost-fa').forEach(initFa);

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.ost-fa');
    if (!section) return;
    fixVideos(e.target);
    requestAnimationFrame(function () { initFa(section); });
  });

}());
